module.exports = __webpack_public_path__ + "assets/img/image12.9b20eb91.png";